export default __webpack_public_path__ + "static/media/bg.e60bcc14.webp";